import { ErrorMessage } from '@hookform/error-message'
import { signOut } from 'firebase/auth'
import { FC, useLayoutEffect, useMemo, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { AiOutlineEdit } from 'react-icons/ai'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { getMiData, putMiData } from '../../../api/mi'
import { auth } from '../../../firebase'
import { useDidUpdateEffect } from '../../../hooks/useDidUpdateEffect'
import { MiUser } from '../../../models/miModel'
import { MiPath, ResendEmailPath } from '../../../routes/path'
import { idTokenState, requestState } from '../../../states/atoms'
import { StyleFormHead } from '../../../styles/mi'
import { Button } from '../../Button'
import { HelperText } from '../../HelperText'
import { Input } from '../Input'

export const ShowMiSection: FC = () => {
  const { idToken, isTokenRequested } = useRecoilValue(idTokenState)
  const [user, setUser] = useState<MiUser>()
  const [collapsedEdit, setCollapsedEdit] = useState<boolean>(true)
  const setRequestState = useSetRecoilState(requestState)

  const onClickOpenEdit = () => {
    setCollapsedEdit(false)
  }

  const onSubmit = async (data: MiUser) => {
    try {
      if (!idToken) return

      await putMiData(data, idToken)
      location.href = MiPath
    } catch (error) {
      setRequestState({
        errorMessage: `アカウント情報の更新に失敗しました。\n時間を置いて再度お試しください。`,
      })
    }
  }

  const defaultValues = useMemo(() => {
    return {
      firstName: user?.firstName,
      lastName: user?.lastName,
    }
  }, [user])

  useLayoutEffect(() => {
    const init = async () => {
      if (!idToken) return

      const data = await getMiData(idToken)
      setUser(data)
    }
    init()
  }, [idToken])

  useDidUpdateEffect(() => {
    reset(defaultValues)
  }, [defaultValues])

  const onClickLogout = async () => {
    setRequestState({ isLoading: true })
    await new Promise((s) => setTimeout(s, 1000))
    setRequestState({ isLoading: false })

    try {
      await signOut(auth)
    } catch (error) {
      setRequestState({
        errorMessage: `ログアウトに失敗しました。
時間を置いて再度お試しください。`,
      })
    }
  }

  const onClickResetPassword = async () => {
    location.href = ResendEmailPath
  }

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm<MiUser>({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: {
      firstName: user?.firstName,
      lastName: user?.lastName,
    },
  })

  return (
    <>
      <div className="containerBase">
        <Container>
          <form className="miForm" onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <StyleFormHead>
                <img src="/images/miproteger-logo.png" alt="" />
                <p>アカウント情報</p>
              </StyleFormHead>
            </Row>
            <Row>
              <hr className="solid"></hr>
            </Row>

            <Row>
              {collapsedEdit ? (
                <div className="edit" onClick={onClickOpenEdit}>
                  <AiOutlineEdit />
                </div>
              ) : (
                <></>
              )}
              <Col xs={6} className="inputBox">
                <ErrorMessage
                  errors={errors}
                  name="lastName"
                  render={({ message }) => <HelperText>*{message}</HelperText>}
                />
                <Input
                  placeholder="姓"
                  isError={!!errors.lastName}
                  {...register('lastName', {
                    required: '姓は必須です',
                    maxLength: 100,
                  })}
                  disabled={collapsedEdit ? true : false}
                />
              </Col>
              <Col xs={6} className="inputBox">
                <ErrorMessage
                  errors={errors}
                  name="firstName"
                  render={({ message }) => <HelperText>*{message}</HelperText>}
                />
                <Input
                  placeholder="名"
                  isError={!!errors.lastName}
                  {...register('firstName', {
                    required: '名は必須です',
                    maxLength: 100,
                  })}
                  disabled={collapsedEdit ? true : false}
                />
              </Col>
            </Row>
            <Row>
              {collapsedEdit ? (
                <>
                  <Col className="button">
                    <Button buttonType="contained" onClick={onClickLogout}>
                      ログアウト
                    </Button>
                  </Col>
                  <Col className="button">
                    <Button buttonType="contained" onClick={onClickResetPassword}>
                      パスワードを変更
                    </Button>
                  </Col>
                </>
              ) : (
                <>
                  <Col className="button">
                    <Button
                      buttonType="contained"
                      isSubmit
                      onClick={() => undefined}
                      disabled={!!Object.keys(errors).length}
                      isFullWidth
                    >
                      変更を保存
                    </Button>
                  </Col>
                </>
              )}
            </Row>
          </form>
        </Container>
      </div>
    </>
  )
}
